import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'additions_hub';
export const route = 'additions_hub/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/AdditionsPage').then(({
  AdditionsPageHub
}) => ({
  default: AdditionsPageHub
}))));